/* eslint-disable global-require */
import angular from 'angular';
import AutoScout24APIController from './autoscout24.controller';

export default angular.module('autoboard.autoscout24API', [])
  .controller('AutoScout24APIController', AutoScout24APIController)
  .name;
